// eslint-disable-next-line import/prefer-default-export
export const FREQUENCY_OPTIONS = [
  'Daily',
  'Weekly',
  'Monthly',
];
